import * as React from 'react'
import { ReactElement } from 'react'
import CommandDialog, { Dismiss } from '../Command/CommandDialog'
import CommandButtons from '../../Form/CommandButtons'

export default function SearchPartyDialog(): ReactElement {
    return (
        <CommandDialog dialogContentProps={{ title: 'Partij zoeken' }}>
            {({ onDismiss }: { onDismiss: Dismiss }) => (
                <>
                    Deze functionaliteit is nog in onwikkeling.
                    <CommandButtons dismiss={onDismiss} dismissButton />
                </>
            )}
        </CommandDialog>
    )
}
